// validation
export const VALIDATE_PLATFORM_TOKEN_REQUEST = 'VALIDATE_PLATFORM_TOKEN_REQUEST';
export const VALIDATE_PLATFORM_TOKEN_SUCCESS = 'VALIDATE_PLATFORM_TOKEN_SUCCESS';
export const VALIDATE_PLATFORM_TOKEN_FAILURE = 'VALIDATE_PLATFORM_TOKEN_FAILURE';
export const VALIDATE_PLATFORM_TOKEN_RESET = 'VALIDATE_PLATFORM_TOKEN_RESET';
